// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"

const getters = {
  // COMPONENT
  // vx-autosuggest
  // starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  windowBreakPoint: (state) => {
    const { windowWidth } = state;
    // This should be same as tailwind. So, it stays in sync with tailwind utility classes
    if (windowWidth >= 1200) return 'xl';
    if (windowWidth >= 992) return 'lg';
    if (windowWidth >= 768) return 'md';
    if (windowWidth >= 576) return 'sm';

    return 'xs';
  },

  scrollbarTag: (state) => {
    return state.is_touch_device ? 'div' : 'VuePerfectScrollbar';
  },
};

export default getters;
